import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BlogsState } from './blogs.reducer';

export const selectBlogsDataState = createFeatureSelector<BlogsState>('blogs');

export const selectBlogsList = createSelector(
  selectBlogsDataState,
  (state: BlogsState) => state.list
);

export const selectBlogsPagination = createSelector(
  selectBlogsDataState,
  (state: BlogsState) => ({
      pageNumber: state.pageNumber,
      pageSize: state.pageSize,
      totalPages: state.totalPages,
      totalRecords: state.totalRecords
  })
);

export const selectBlogsDataLoading = createSelector(
    selectBlogsDataState,
    (state: BlogsState) => state.loading
);

export const selectBlogsDataError = createSelector(
    selectBlogsDataState,
    (state: BlogsState) => state.error
);

export const selectBlogsDetail = createSelector(
  selectBlogsDataState,
  (state: any) => state.detail
);

export const selectBlogsDetailLoading = createSelector(
  selectBlogsDataState,
    (state: any) => state.loading
);

export const selectBlogsDetailError = createSelector(
    selectBlogsDataState,
    (state: BlogsState) => state.error
);
